import React from "react";
import EstadoCompraBadge from "../components/ui/EstadoCompraBadge";
import {
    formatCantidadCompra,
    formatFechaCompra,
    formatFechaHoraCompra,
    formatTextoCompra,
} from "./estadosCompras";

/**
 * Columnas del DataGrid de estados de compras (constante de módulo: no se recrean por render)
 */
export const ESTADOS_COMPRAS_COLUMNS = [
    { field: "numeroPedido", headerName: "Pedido", flex: 1 },
    { field: "proveedor", headerName: "Proveedor", flex: 1 },
    {
        field: "entrega",
        headerName: "Fecha entrega",
        flex: 1,
        valueFormatter: (params) => formatFechaCompra(params?.value),
    },
    {
        field: "pendientes",
        headerName: "Unidades por puntear",
        flex: 1,
        valueFormatter: (params) => formatCantidadCompra(params?.value),
    },
    {
        field: "productos",
        headerName: "Productos por puntear",
        flex: 1,
        valueFormatter: (params) => formatCantidadCompra(params?.value),
    },
    {
        field: "recepcionado",
        headerName: "Recepcionado por",
        flex: 1,
        valueFormatter: (params) => formatTextoCompra(params?.value),
    },
    {
        field: "fechaRecepcion",
        headerName: "Fecha recepción",
        type: "dateTime",
        flex: 1,
        valueGetter: (params) => (params?.value ? new Date(params.value) : null),
        valueFormatter: (params) => formatFechaHoraCompra(params?.value),
    },
    {
        field: "estado",
        headerName: "Estado",
        flex: 1,
        filterable: false,
        renderCell: (params) => <EstadoCompraBadge estado={params.value} />,
    },
];

/**
 * Devuelve las columnas del DataGrid de estados de compras
 */
export const generateEstadosComprasColumns = () => ESTADOS_COMPRAS_COLUMNS;
